import * as React from 'react';
import { Switch as DesignSwitch } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const Switch = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignSwitch {...formItemSettings} className={className} valuePropName="checked" />
    </FormItem>
  );
};

export default Switch;
